import { UI, HStack, Stack, VStack } from '@genial/components';
import { BoxBorder, Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React from 'react';
import { FlatList } from 'react-native-gesture-handler';

import { LoadingTable } from '../LoadingTable';

import { tableHead } from './constants';

import { PlatformQueryContainerDataProps } from '.';

interface ProductItemProps {
  item: PlatformQueryContainerDataProps['data'][0];
}

export const ProductItemValueMobile: React.FC<{ value: string; label: string }> = ({
  value,
  label,
}) => {
  return (
    <HStack
      justifyContent="space-between"
      py={Spacing['stack.nano']}
      space={Spacing['stack.quarck']}>
      <UI.Text variant="semibold" fontSize={Typography['fontsize.md']}>
        {label}
      </UI.Text>
      <UI.Text textAlign="right" fontSize={Typography['fontsize.md']}>
        {value}
      </UI.Text>
    </HStack>
  );
};

export const ProductItemMobile: React.FC<ProductItemProps> = ({ item }) => {
  return (
    <UI.Shadow
      level={1}
      p={Spacing['inset.xs']}
      my={Spacing['stack.nano']}
      borderRadius={BoxBorder.heavy}>
      <VStack>
        <Stack pb={Spacing['stack.nano']} mb={Spacing['stack.quarck']}>
          <UI.Text variant="semibold" color={'neutral.dark'} fontSize={Typography['fontsize.lg']}>
            {item.toolName}
          </UI.Text>
        </Stack>

        <ProductItemValueMobile label={tableHead.package} value={item.packageName} />
        <ProductItemValueMobile
          label={tableHead.initialDate}
          value={Utils.Mask.DateFormat(item.hiringDate, 'dd/MM/yyyy - HH:mm:ss')}
        />
        <ProductItemValueMobile
          label={tableHead.finalDate}
          value={
            item.cancelDate ? Utils.Mask.DateFormat(item.cancelDate, 'dd/MM/yyyy - HH:mm:ss') : '--'
          }
        />
        <ProductItemValueMobile
          label={tableHead.adhesionStatus}
          value={item.hiringStateDescription}
        />
      </VStack>
    </UI.Shadow>
  );
};

export const ContentMobile: React.FC<PlatformQueryContainerDataProps> = ({ isLoading, data }) => {
  return (
    <VStack my={Spacing['inset.xs']}>
      {isLoading ? (
        <LoadingTable columns={5} items={3} isMobile />
      ) : (
        <FlatList
          windowSize={20}
          maxToRenderPerBatch={20}
          updateCellsBatchingPeriod={5}
          data={data}
          // ListEmptyComponent={<LoadingTable columns={columns} />}
          showsVerticalScrollIndicator={false}
          // onEndReached={handleEndReached}
          onEndReachedThreshold={1.5}
          // ListFooterComponent={loadingFooter}
          renderItem={({ item }) => <ProductItemMobile item={item} />}
        />
      )}
    </VStack>
  );
};
